import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import check from "../../../../../../assets/images/check.svg";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import cancel from "../../../../../../assets/images/cancel.svg";
import ButtonComp from "../../../../../../components/Button";
type DeclinedDraftPopupProps = {
  open: boolean;
  onClose: () => void;
  label: string;
  text?: string;
  flags: {
    claimAlreadyPresent: boolean;
    fiveYearsActive: boolean;
    policyLapsed: boolean;
  };
};

const DeclinedDraftPopup: React.FC<DeclinedDraftPopupProps> = ({
  open,
  onClose,
  label,
  text,
  flags,
}) => {
  const theme = useTheme();
  const { fiveYearsActive, policyLapsed, claimAlreadyPresent } = flags;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "visible",
          px: 4,
          pt: 10,
          pb: 3,
          position: "relative",
          boxShadow: "inset 0 0 12px rgba(0, 0, 0, 0.2)",
          borderBottom: "6px solid #E8003F",
          height: 580,
        },
      }}
    >
      {/* Top Red Circle */}
      <Box
        sx={{
          position: "absolute",
          top: -60,
          left: "50%",
          transform: "translateX(-50%)",
          width: 125,
          height: 125,
          borderRadius: "50%",
          backgroundColor: "background.paper",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "inset 0 0 12px rgba(0, 0, 0, 0.2)",
          zIndex: 1,
        }}
      >
        <img
          src={cancel}
          alt="Reject"
          style={{ height: 70, width: 70, objectFit: "contain" }}
        />
      </Box>

      {/* Heading */}
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={1}
        mb={2}
      >
        <Typography
          fontSize={{ xs: 26, sm: 38 }}
          fontWeight={600}
          color="#E8003F"
        >
          {label}
        </Typography>
        <Typography
          fontSize={{ xs: 12, sm: 16 }}
          fontWeight={600}
          color="text.secondary"
        >
          {text}
        </Typography>
      </Box>

      {/* Flags info */}
      <Box textAlign="left" mb={2}>
        {/* 5 Year Completion */}
        <Box display="flex" alignItems="flex-start" mb={1}>
          <img
            src={fiveYearsActive ? check : cancel}
            alt="Status Icon"
            style={{ height: 20, width: 20 }}
          />
          <Box ml={1}>
            <Typography fontWeight={600} fontSize={{ xs: 13, sm: 16 }}>
              5 Years of Continuous Coverage
            </Typography>
            <Typography
              variant="body2"
              color={fiveYearsActive ? "green" : "red"}
              fontSize={{ xs: 12, sm: 16 }}
            >
              {fiveYearsActive
                ? "Your policy has been active for the past 5 years without any missed or defaulted payments."
                : "Your policy has not completed 5 years of continuous coverage."}
            </Typography>
          </Box>
        </Box>

        {/* No Previous Claims */}
        <Box display="flex" alignItems="flex-start" mb={1}>
          <img
            src={claimAlreadyPresent ? check : cancel}
            alt="Status Icon"
            style={{ height: 20, width: 20 }}
          />
          <Box ml={1}>
            <Typography fontWeight={600} fontSize={{ xs: 13, sm: 16 }}>
              No Previous Claims
            </Typography>
            <Typography
              variant="body2"
              color={claimAlreadyPresent ? "green" : "red"}
              fontSize={{ xs: 12, sm: 16 }}
            >
              {claimAlreadyPresent
                ? "We found no history of claims associated with your policy."
                : "You have already made a claim on this policy."}
            </Typography>
          </Box>
        </Box>

        {/* Policy Lapsed */}
        <Box display="flex" alignItems="flex-start" mb={1}>
          <img
            src={policyLapsed ? check : cancel}
            alt="Status Icon"
            style={{ height: 20, width: 20 }}
          />
          <Box ml={1}>
            <Typography fontWeight={600} fontSize={{ xs: 13, sm: 16 }}>
              Policy Has Never Lapsed
            </Typography>
            <Typography
              variant="body2"
              color={policyLapsed ? "green" : "red"}
              fontSize={{ xs: 12, sm: 16 }}
            >
              {policyLapsed
                ? "Your policy has remained active and uninterrupted since its inception."
                : "Your policy has lapsed at some point in the past."}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Final Message */}
      <Typography mb={3} fontWeight={700} fontSize={{ xs: 12, sm: 16 }}>
        If you believe this is an error or need help understanding your
        eligibility, please contact 0860007580.

      </Typography>

      {/* OK Button */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          // py: {xs:0, sm:0},
        }}
      >
        <ButtonComp
          variant="outlined"
          height={40}
          fontSize="16px"
          width={190}
          onClick={onClose}
        >
          OK
        </ButtonComp>
      </Box>
    </Dialog>
  );
};

export default DeclinedDraftPopup;
